<ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" *ngIf="mode === 'create'">{{"LEVEL_MODE_CREATE" | translate}}</h4>
      <h4 class="modal-title" *ngIf="mode === 'update'">{{"LEVEL_MODE_UPDATE" | translate}}</h4>
      <h4 class="modal-title" *ngIf="mode === 'read'">{{"LEVEL_MODE_READ" | translate}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body formModal">


        <app-progressbar *ngIf="showSpinner===true"></app-progressbar>

        <mat-horizontal-stepper [linear]="true" #stepper *ngIf="!readOnly">
            <mat-step [stepControl]="levelForm">

                <form [formGroup]="levelForm" *ngIf="levelForm">
                    <ng-template matStepLabel>{{'INFORMATION' | translate}}</ng-template>
                    <mat-form-field>
                        <input matInput [placeholder]="'NAME' | translate" formControlName="name" required>
                        <mat-error *ngIf="name.invalid">{{getErrorMessageName()}}</mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <input matInput [placeholder]="'EMAIL' | translate" formControlName="email" required>
                        <mat-error *ngIf="email.invalid">{{getErrorMessageEmail()}}</mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-select formControlName="lang" [placeholder]="'LANG' | translate" required>
                            <mat-option value="fr">fr</mat-option>
                            <mat-option value="en">en</mat-option>
                        </mat-select>
                        <mat-error *ngIf="lang.invalid">{{getErrorMessageLang()}}</mat-error>
                    </mat-form-field>

                    <mat-slide-toggle formControlName="active"
                                      [(ngModel)]="active">{{levelForm.value.active ? ('ACTIVE' | translate) : ('INACTIVE' | translate)}}</mat-slide-toggle>
                    <br/>
                    <div>
                        <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
                            Next
                        </button>
                    </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="levelAdressForm">
                <form [formGroup]="levelAdressForm" *ngIf="levelAdressForm">
                    <ng-template matStepLabel>{{'ADDRESS' | translate}}</ng-template>

                    <mat-form-field>
                        <input matInput [placeholder]="'ADDRESS1' | translate" formControlName="address1">
                    </mat-form-field>

                    <mat-form-field>
                        <input matInput [placeholder]="'ADDRESS2' | translate" formControlName="address2">
                    </mat-form-field>
                    <br/>
                    <mat-form-field>
                        <input matInput [placeholder]="'ZIPCODE' | translate" formControlName="zip">
                    </mat-form-field>

                    <mat-form-field>
                        <input matInput [placeholder]="'CITY' | translate" formControlName="city">
                    </mat-form-field>

                    <mat-form-field>
                        <input matInput [placeholder]="'COUNTRY' | translate" formControlName="country">
                    </mat-form-field>
                    <br/>

                    <mat-form-field style="width:90%">
                        <input matInput [placeholder]="'NOTES' | translate" formControlName="notes">
                    </mat-form-field>
                    <div>
                        <button class="btn btn-info" mat-button matStepperPrevious
                                [innerHTML]="'BACK_BUTTON' | translate">Back
                        </button>
                        <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
                            Next
                        </button>
                    </div>
                </form>

            </mat-step>


            <mat-step>
                <ng-template matStepLabel>{{'CHECK_SAVE' | translate}}</ng-template>


                <div><b [innerHtml]="'INFORMATION' | translate">Information</b></div>
                <div *ngIf="levelForm">
                    <mat-form-field class="readonly">
                        <input matInput [placeholder]="'NAME' | translate" [value]="levelForm.value.name"
                               [readonly]="true">

                    </mat-form-field>

                    <mat-form-field class="readonly">
                        <input matInput [placeholder]="'EMAIL' | translate" [value]="levelForm.value.email"
                               [readonly]="true">

                    </mat-form-field>

                    <mat-form-field class="readonly">
                        <mat-select [value]="levelForm.value.lang" [placeholder]="'LANG' | translate" [disabled]="true">
                            <mat-option value="fr">fr</mat-option>
                            <mat-option value="en">en</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-slide-toggle [(ngModel)]="levelForm.value.active"
                                      [disabled]="true">{{levelForm.value.active ? ('ACTIVE' | translate) : ('INACTIVE' | translate)}}</mat-slide-toggle>
                </div>

                <div><b [innerHtml]="'ADDRESS' | translate">Address</b></div>

                <mat-form-field class="readonly">
                    <input matInput [placeholder]="'ADDRESS1' | translate"
                           [value]="levelAdressForm.value.address1 ? levelAdressForm.value.address1 : ' '"
                           [readonly]="true">
                </mat-form-field>

                <mat-form-field class="readonly">
                    <input matInput [placeholder]="'ADDRESS2' | translate"
                           [value]="levelAdressForm.value.address2 ? levelAdressForm.value.address2 : ' '"
                           [readonly]="true">
                </mat-form-field>
                <br/>
                <mat-form-field class="readonly">
                    <input matInput [placeholder]="'ZIPCODE' | translate"
                           [value]="levelAdressForm.value.zip ? levelAdressForm.value.zip : ' ' "
                           [readonly]="true">
                </mat-form-field>

                <mat-form-field class="readonly">
                    <input matInput [placeholder]="'CITY' | translate"
                           [value]="levelAdressForm.value.city ? levelAdressForm.value.city  : ' '"
                           [readonly]="true">
                </mat-form-field>

                <mat-form-field class="readonly">
                    <input matInput [placeholder]="'COUNTRY' | translate"
                           [value]="levelAdressForm.value.country ? levelAdressForm.value.country  : ' '"
                           [readonly]="true">
                </mat-form-field>

                <mat-form-field style="width:90%" class="readonly">
                    <input matInput [placeholder]="'NOTES' | translate"
                           [value]="levelAdressForm.value.notes ? levelAdressForm.value.notes : ' '"
                           [readonly]="true">
                </mat-form-field>

                <div>
                    <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
                        Back
                    </button>
                    <button type="button" class="btn btn-warning" (click)="persistLevel()">
                        <app-progressbar *ngIf="showSpinner===true"></app-progressbar>
                        {{'SAVE'|translate}}</button>


                </div>
            </mat-step>

        </mat-horizontal-stepper>


        <div *ngIf="readOnly">


            <div><b [innerHtml]="'INFORMATION' | translate">Information</b></div>
            <mat-form-field class="readonly">
                <input matInput [placeholder]="'NAME' | translate" [value]="levelForm.value.name" [readonly]="true">

            </mat-form-field>

            <mat-form-field class="readonly">
                <input matInput [placeholder]="'EMAIL' | translate" [value]="levelForm.value.email" [readonly]="true">

            </mat-form-field>

            <mat-form-field class="readonly">
                <mat-select [value]="levelForm.value.lang" [placeholder]="'LANG' | translate" [disabled]="true">
                    <mat-option value="fr">fr</mat-option>
                    <mat-option value="en">en</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-slide-toggle [(ngModel)]="levelForm.value.active"
                              [disabled]="true">{{levelForm.value.active ? ('ACTIVE' | translate) : ('INACTIVE' | translate)}}</mat-slide-toggle>


            <div><b [innerHtml]="'ADDRESS' | translate">Address</b></div>

            <mat-form-field class="readonly">
                <input matInput [placeholder]="'ADDRESS1' | translate"
                       [value]="levelAdressForm.value.address1 ? levelAdressForm.value.address1 : ' '"
                       [readonly]="true">
            </mat-form-field>

            <mat-form-field class="readonly">
                <input matInput [placeholder]="'ADDRESS2' | translate"
                       [value]="levelAdressForm.value.address2 ? levelAdressForm.value.address2 : ' '"
                       [readonly]="true">
            </mat-form-field>
            <br/>
            <mat-form-field class="readonly">
                <input matInput [placeholder]="'ZIPCODE' | translate"
                       [value]="levelAdressForm.value.zip ? levelAdressForm.value.zip : ' ' "
                       [readonly]="true">
            </mat-form-field>

            <mat-form-field class="readonly">
                <input matInput [placeholder]="'CITY' | translate"
                       [value]="levelAdressForm.value.city ? levelAdressForm.value.city  : ' '"
                       [readonly]="true">
            </mat-form-field>

            <mat-form-field class="readonly">
                <input matInput [placeholder]="'COUNTRY' | translate"
                       [value]="levelAdressForm.value.country ? levelAdressForm.value.country  : ' '" [readonly]="true">
            </mat-form-field>

            <mat-form-field style="width:90%" class="readonly">
                <input matInput [placeholder]="'NOTES' | translate"
                       [value]="levelAdressForm.value.notes ? levelAdressForm.value.notes : ' '"
                       [readonly]="true">
            </mat-form-field>


        </div>


    </div>
    <div class="modal-footer">

        <button type="button" class="btn btn-light" (click)="closeModal()" [innerHTML]="'CLOSE' | translate">Close
        </button>
    </div>
</ng-template>


<button *ngIf="mode ==='read'" type="button" class="btn list-tools" (click)="openModal(content)" placement="left"
        [ngbTooltip]="'READ_ICON_TOOLTIP' | translate">
    <fa-icon [icon]="faEye"></fa-icon>
</button>

<button *ngIf="mode ==='create' && authenticationService.currentUserCanManageLevels()" type="button"
        class="btn top-list-tools" (click)="openModal(content)" placement="left"
        [ngbTooltip]="'CREATE_ICON_TOOLTIP' | translate">
    <fa-icon [icon]="faPlus"></fa-icon>
    {{'ADD_LEVEL'|translate}}
</button>


<button *ngIf="mode ==='update' && authenticationService.currentUserCanManageLevels()" type="button"
        class="btn list-tools" (click)="openModal(content)" placement="top"
        [ngbTooltip]="'UPDATE_ICON_TOOLTIP' | translate">
    <fa-icon [icon]="faEdit"></fa-icon>
</button>
